<script>
  import RequiredLabel from '../components/RequiredLabel'
  import flatFragment from './flatFragment'

  export default {
    name: 'InlineLayout',

    props: {
      label: {
        type: String,
        default: '',
      },
      comment: {
        type: String,
        default: '',
      },
      required: {
        type: Boolean,
        default: false,
      },
    },
    setup(props, { slots }) {
      return () => {
        const flatten = flatFragment(slots.default())
        return (
          <div>
            <RequiredLabel
              label={props.label}
              comment={props.comment}
              required={props.required}
            />

            <div class="inline-layout" style={{ display: 'flex', flexWrap: 'wrap' }}>
              {flatten.map((child, i) => (
                <div
                  style={{ marginRight: '20px' }}
                  class="item"
                  key={i}
                >
                  {child}
                </div>
              ))}
            </div>
          </div>
        )
      }
    },
  }
</script>
